import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {UserService} from '../services/user/user.service';
import {NavigationService} from '../services/nav/navigation.service';
import {UserDto} from '@api/utisha-backend';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  loggedIn: boolean;

  constructor(private userService: UserService,
              private navService: NavigationService) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

    try {
      await this.userService.getUser();
      return Promise.resolve(true);
    } catch (ex) {
      this.navService.login();
    }
    return Promise.resolve(false);
  }

}
